// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"dc3efdb5","268":"ccc5b0a7","274":"761e3167","398":"fd887aa5","427":"2df9c546","453":"799de051","752":"734c2b78","945":"022e47a3"}[chunkId] + ".chunk.js";
};